import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import DesktopViewContext from "../context/DesktopViewContext";
import NewClientRequest from "./NewClientRequest";
const CreateJob = ({ }) => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const {desktopView} = useContext(DesktopViewContext);
  const [licenseTypes, setLicenseTypes] = useState([]);
  const [additionalLicenses, setAdditionalLicenses] = useState([]);
  const [placeOfWork, setPlaceOfWork] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [salaryDuration, setSalaryDuration] = useState([]);
  const [language, setLanguage] = useState([]);
  const [trailerType, setTrailerType] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [beginner, setBeginner] = useState([]);
  const [pav, setPav] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [jobName, setJobName] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [tel1, setTel1] = useState("");
  const [tel2, setTel2] = useState("");
  const [email, setEmail] = useState("");
  const [isRange, setIsRange] = useState(false); // Toggle between fixed salary or range
  const [salaryFrom, setSalaryFrom] = useState(null);
  const [salaryTo, setSalaryTo] = useState("");

  
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;

  useEffect(() => {
    const fetchJobInputs = async () => {
      try {
        const response = await fetch(api_endpoint + "/api/inputs");
        const fetchedData = await response.json();

        // Initialize all fields with "selected" field
        const initializeSelection = (items) =>
          items.map((item) => ({ ...item, selected: 0 }));

        setLicenseTypes(initializeSelection(fetchedData.license_type));
        setAdditionalLicenses(
          initializeSelection(fetchedData.additional_licenses)
        );
        setPlaceOfWork(initializeSelection(fetchedData.place_of_work));
        setEmploymentType(initializeSelection(fetchedData.employment_type));
        setSalaryDuration(initializeSelection(fetchedData.salary_duration));
        setLanguage(initializeSelection(fetchedData.language));
        setTrailerType(initializeSelection(fetchedData.trailer_type));
        setVehicle(initializeSelection(fetchedData.vehicle));
        setJobType(initializeSelection(fetchedData.job_type));
        setBeginner(initializeSelection(fetchedData.beginner));
        setPav(initializeSelection(fetchedData.pav));

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    const fetchCompany = async () => {
      try {
        const response = await fetch(api_endpoint + "/api/user/company", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(user),
        });
        const fetchedData = await response.json();
        setCompanyLocation(fetchedData.location);
        setCompanyEmail(fetchedData.email);
        if (fetchedData.logo) {
          setCompanyLogo(fetchedData.logo);
        }
        if (fetchedData.uploaded_logo && fetchedData.uploaded_logo.data) {
          let blobImageArray = new Uint8Array([...atob(String.fromCharCode.apply(null, fetchedData.uploaded_logo.data))].map(c => c.charCodeAt(0)));
          const blob = new Blob([blobImageArray], { type: 'image/png' });
          const imageUrl = URL.createObjectURL(blob);
          setCompanyLogo(imageUrl);
        }
        setCompanyName(fetchedData.name);
        setTel1(fetchedData.tel1);
        setTel2(fetchedData.tel2);
        setEmail(fetchedData.email);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    fetchCompany();
    fetchJobInputs();
  }, [user]);

  const handleSelectionChange = (stateSetter, currentState, id) => {
    stateSetter(
      currentState.map((item) =>
        item.id === id
          ? { ...item, selected: item.selected === 2 ? 0 : item.selected + 1 }
          : item
      )
    );
  };
  const navigateToHome = () => {
    navigate("/"); 
  };
  const navigateToRequest = () => {
    navigate("/"); 
  };
  const handleSubmit = async () => {
    try {
      // List of all skill arrays
      const allSkillArrays = [
        licenseTypes,
        additionalLicenses,
        placeOfWork,
        employmentType,
        salaryDuration,
        language,
        trailerType,
        vehicle,
        jobType,
        beginner,
        pav,
      ];

      // Function to collect IDs by selected type
      const collectSkillIds = (selectionType) =>
        allSkillArrays.flatMap((skillArray) =>
          skillArray
            .filter((item) => item.selected === selectionType)
            .map((item) => item.id)
        );

      // Collect skills
      const requiredSkills = collectSkillIds(1); // Selected as "Required"
      const nicetohaveSkills = collectSkillIds(2); // Selected as "Nice-to-Have"

      // Construct the request body
      const jobData = {
        user: user, // Assuming `user` is passed as a prop
        name: jobName,
        description: jobDescription,
        youtube: youtubeLink,
        min_salary: salaryFrom == "" ? null : salaryFrom,
        max_salary: isRange ? salaryTo : null,
        requiredSkills,
        nicetohaveSkills,
      };

      const response = await fetch(api_endpoint + "/api/jobs/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Job created successfully:", result);
        navigateToHome();
      } else {
        console.error("Error creating job:", response.statusText);
      }
    } catch (error) {
      console.error("Error during job submission:", error);
    }
  };



  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (user && (user.type == "poster" || user.type == "admin")) {
    return (
      <div className="job-apply-container">
        <h3>Álláshirdetés feladása</h3>
        <div className="input-group">
          <label htmlFor="companyName">Cég neve: {companyName} </label>
          <br></br>
     <label htmlFor="companyLocation">Cég helye: {companyLocation} </label>  
     <br></br>
      <label htmlFor="email">Cég email: {companyEmail}</label> 
      <br></br>
       <label htmlFor="companylogo">Cég logó: </label>
       <br></br>
       <img
          src={companyLogo}
          alt={`nincs céges logó, vagy hibás linket - hibás fájlt töltött fel`}
          className="job-company-logo"
        />
       <br></br>
       <br></br>
      <button onClick={()=> navigate("/company")}> Céges adatok módosítása</button>
        </div>
        {/* Job Name and Description */}
        <div className="input-group">
          <label htmlFor="jobName">Munka megnevezése</label>
          <input
            type="text"
            id="jobName"
            value={jobName}
            onChange={(e) => setJobName(e.target.value)}
            placeholder="Munka megnevezése"
          />
        </div>

        <div className="input-group">
          <label htmlFor="jobDescription">Munka leírása</label>
          <textarea
            id="jobDescription"
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
            placeholder="Munka rövid leírása"
          />
        </div>
        {/* YouTube Link Input */}
        <div className="input-group">
          <label htmlFor="youtubeLink">YouTube Link</label>
          <input
            type="url"
            id="youtubeLink"
            value={youtubeLink}
            onChange={(e) => setYoutubeLink(e.target.value)}
            placeholder="YouTube link megadása"
          />
        </div>
        <div className="input-group">
          <label>Fizetés</label>
          <div className="job-inputs-container">
            <input
              type="number"
              value={salaryFrom}
              onChange={(e) => setSalaryFrom(e.target.value)}
              placeholder={isRange ? "Tól" : "Fix fizetés megadása"}
              min="0"
            />

            {isRange && (
              <>
                <span>-</span>
                <input
                  type="number"
                  value={salaryTo}
                  onChange={(e) => setSalaryTo(e.target.value)}
                  placeholder="Ig"
                  min="0"
                />
              </>
            )}
            <></>
            <button
              className="apply-button"
              type="button"
              onClick={() => setIsRange(!isRange)}
            >
              {isRange
                ? "Váltás fix bérezésre"
                : "Váltás bértartomány megadására"}
            </button>
          </div>
        </div>

        <div className="job-inputs-container">
          <div>
            <h4>Segítség a képesítések kitöltéséhez</h4>
            <div className="multiselect">
              <div key={0} className={`multiselect-item`}>
                Nem kell a munkához
              </div>
              <div key={1} className={`multiselect-item selected-orange`}>
                Kötelező
              </div>
              <div key={2} className={`multiselect-item selected-blue`}>
                Jó ha tudja
              </div>
            </div>
          </div>
          {/* License Types Multi-Select */}
          <div className="input-group">
            <h4>Jogosítvány</h4>
            <div className="multiselect">
              {licenseTypes.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(
                      setLicenseTypes,
                      licenseTypes,
                      item.id
                    )
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Additional Licenses Multi-Select */}
          <div className="input-group">
            <h4>Egyéb képesítések</h4>
            <div className="multiselect">
              {additionalLicenses.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(
                      setAdditionalLicenses,
                      additionalLicenses,
                      item.id
                    )
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Place of Work Multi-Select */}
          <div className="input-group">
            <h4>Munkavégzés helye</h4>
            <div className="multiselect">
              {placeOfWork.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setPlaceOfWork, placeOfWork, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Employment Type Multi-Select */}
          <div className="input-group">
            <h4>Munkavállalás típusa</h4>
            <div className="multiselect">
              {employmentType.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(
                      setEmploymentType,
                      employmentType,
                      item.id
                    )
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Salary Duration Multi-Select */}
          <div className="input-group">
            <h4>Fizetés frekvencia</h4>
            <div className="multiselect">
              {salaryDuration.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(
                      setSalaryDuration,
                      salaryDuration,
                      item.id
                    )
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Language Multi-Select */}
          <div className="input-group">
            <h4>Beszélt nyelvek</h4>
            <div className="multiselect">
              {language.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setLanguage, language, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Trailer Type Multi-Select */}
          <div className="input-group">
            <h4>Tréler</h4>
            <div className="multiselect">
              {trailerType.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setTrailerType, trailerType, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Vehicle Multi-Select */}
          <div className="input-group">
            <h4>Jármű</h4>
            <div className="multiselect">
              {vehicle.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setVehicle, vehicle, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Job Type Multi-Select */}
          <div className="input-group">
            <h4>Munka típusa</h4>
            <div className="multiselect">
              {jobType.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setJobType, jobType, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* Beginner Multi-Select */}
          <div className="input-group">
            <h4>Kezdő</h4>
            <div className="multiselect">
              {beginner.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() =>
                    handleSelectionChange(setBeginner, beginner, item.id)
                  }
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          {/* PAV Multi-Select */}
          <div className="input-group">
            <h4>PAV</h4>
            <div className="multiselect">
              {pav.map((item) => (
                <div
                  key={item.id}
                  className={`multiselect-item ${
                    item.selected === 1
                      ? "selected-orange"
                      : item.selected === 2
                      ? "selected-blue"
                      : ""
                  }`}
                  onClick={() => handleSelectionChange(setPav, pav, item.id)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>

          <div className="input-group"></div>
        </div>
        <div className={desktopView ? "footer-desktop" : "footer"}>
          <button className="back-button" onClick={navigateToHome}>
            Vissza a főoldalra
          </button>
          <button className="apply-button" onClick={handleSubmit}>
            Hirdetés feladása
          </button>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <NewClientRequest/>  
    );
  }

  if (!user || (user && user.type == null) ) {
    return (
      <button className="apply-button" onClick={()=> setUser(null)}>
      Előfizetése lejárt ekkor: {(user.poster_until).replace(":00.000Z", "").replace("T"," ")}. Kattintson és kérjen új ajánlatot!
    </button>
    );
  }
};

export default CreateJob;
